import { Component, ElementRef, OnDestroy, afterNextRender, inject } from '@angular/core';
import { gsap } from '../../../motion/gsap';
import { QUERIES } from '../../../motion/motion-env';
import { MotionService } from '../../../motion/motion.service';

interface SocialLink {
  label: 'Facebook' | 'Instagram';
  icon: string;
  link: string;
}

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
})
export class FooterComponent implements OnDestroy {
  private readonly motion = inject(MotionService);
  private readonly host: HTMLElement = inject(ElementRef).nativeElement;
  private mm?: ReturnType<typeof gsap.matchMedia>;
  private destroyed = false;

  socialMedia: SocialLink[] = [
    {
      label: 'Facebook',
      icon: 'icofont icofont-social-facebook',
      link: 'https://www.facebook.com/profile.php?id=61567968185309&mibextid=wwXIfr&mibextid=wwXIfr',
    },
    {
      label: 'Instagram',
      icon: 'brand-icon brand-icon--instagram',
      link: 'https://www.instagram.com/drivon__autoschool',
    },
  ];

  constructor() {
    afterNextRender(() => this.motion.whenNeeded(this.host, () => this.destroyed || this.setupLane()));
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    this.mm?.revert();
  }

  trackByIndex(index: number): number {
    return index;
  }

  /**
   * The lane dashes along the top edge rush in once when the footer arrives; static otherwise.
   * Footer triggers start at the viewport's bottom edge: the footer ends the page, so a line
   * higher up the viewport may lie beyond the maximum scroll (the social icons' reveal starts
   * 100px early for the same reason).
   */
  private setupLane(): void {
    const footer = this.host.querySelector<HTMLElement>('footer.footer');
    const strip = footer?.querySelector<HTMLElement>('.footer-lane__strip');
    if (!footer || !strip) return;

    const mm = (this.mm = gsap.matchMedia(footer));
    mm.add(QUERIES.motion, () => {
      gsap.fromTo(
        strip,
        { xPercent: -50 },
        {
          xPercent: 0,
          duration: 1.2,
          ease: 'expo.out',
          scrollTrigger: { trigger: footer, start: 'top bottom', once: true },
        }
      );
    });
  }
}
